<template>
  <ViewGaia></ViewGaia>
</template>
<script>
import ViewGaia from "@/components/IAReputation/Views/Gaia.vue"


export default {
  components: {ViewGaia},

}
</script>
